import * as v from 'valibot';

import { TransactionError, TransactionResult } from '../query/errors.types';
import { HTTPError } from './ky';

export class ValidationError extends Error {}

declare module '@tanstack/react-query' {
	interface Register {
		defaultError: HTTPError | ValidationError;
	}
}

export const logIssues = function <T>(
	issues: [...v.InferIssue<v.GenericSchema<T>>[]],
) {
	console.log(
		issues
			.map(
				(issue) =>
					`${
						issue.path
							?.map((p, i) =>
								p.type === 'object' ? `\x1B[33m${i ? '.' : ''}${p.key}\x1B[m`
								: p.type === 'array' ?
									`\x1B[93m[\x1B[33m${p.key}\x1B[93m]\x1B[m`
								:	p.type,
							)
							.join('') ?? ''
					}\x1B[m - \x1B[1;34m${issue.message}\x1B[m - (got: \x1B[1;41m${issue.received}\x1B[m, expected: \x1B[1;30;102m${issue.expected ?? ''}\x1B[m)`,
			)
			.join('\n'),
	);
};

export const parseSchema =
	<Input, Output = Input>(schema: v.GenericSchema<Input, Output>) =>
	async (response: Response) => {
		const json: unknown = await response.json();
		const result = v.safeParse(schema, json);
		if (result.success) {
			return result.output;
		}
		logIssues(result.issues);
		throw new ValidationError(
			'Invalid data received from API - see console for details',
		);
	};

export const handleError =
	(keys: readonly string[]) => async (error: unknown) => {
		if (error instanceof HTTPError) {
			if (error.response.status === 401) {
				throw error;
			}

			const data = await error.response.json<TransactionResult<object>>();
			throw new TransactionError(v.parse(TransactionResult(keys), data));
		}

		throw error;
	};
